import {
  GalleryOffer,
  ObjectIdAsHexString,
} from "kreate-common/modules/business-types";
import { z } from "zod";

export const Params = z
  .object({
    // user scope
    userId: ObjectIdAsHexString.optional(),
    addressOrHandle: z.string().optional(),
    listType: z.enum(["sent", "received"]),
    // sorting, paging
    offset: z.coerce.number(),
    limit: z.coerce.number(),
    // orderBy `price` only works in ForSale page
    // minted_at works in any page
    orderBy: z.enum(["price", "minted_at"]).optional(),
    orderDirection: z.union([z.literal("asc"), z.literal("desc")]).optional(),
  })
  .refine((data) => !!data.addressOrHandle || !!data.userId, {
    message: "Required addressOrHandle or userId",
  });

export type Params = z.infer<typeof Params>;

export const Result = z.object({
  offers: GalleryOffer.array(),
  count: z.number(),
});
export type Result = z.infer<typeof Result>;

export const GetGalleryOfferList$Params = Params;
export type GetGalleryOfferList$Params = Params;
export const GetGalleryOfferList$Result = Result;
export type GetGalleryOfferList$Result = Result;
